import React, { useState, useCallback } from "react";
import Heading from "../ui/Heading";
import { Col, Container, Image, Row } from "react-bootstrap";
import { Link, useHistory } from "react-router-dom/cjs/react-router-dom";
import { isMobile, isTablet } from "react-device-detect";
import Slider from "react-slick";
import { ImageUrl, Je_welryspelling } from "../../../../../Helpers/request";
import Round from '../../../../../Assets/nokaoi-imges/diamond-shape-img/Coloured/Round.svg';
import Princess from '../../../../../Assets/nokaoi-imges/diamond-shape-img/Coloured/Princess.svg';
import Cushion from '../../../../../Assets/nokaoi-imges/diamond-shape-img/Coloured/Cushion.svg';
import Emerald from '../../../../../Assets/nokaoi-imges/diamond-shape-img/Coloured/Emerald.svg';
import Oval from '../../../../../Assets/nokaoi-imges/diamond-shape-img/Coloured/Oval.svg';
import Marquise from '../../../../../Assets/nokaoi-imges/diamond-shape-img/Coloured/Marquise.svg';
import Radiant from '../../../../../Assets/nokaoi-imges/diamond-shape-img/Coloured/Radiant.svg';
import Pear from '../../../../../Assets/nokaoi-imges/diamond-shape-img/Coloured/Pear.svg';
import Asscher from '../../../../../Assets/nokaoi-imges/diamond-shape-img/Coloured/Asscher.svg';
import Heart from '../../../../../Assets/nokaoi-imges/diamond-shape-img/Coloured/Heart.svg';

import RoundBlack from '../../../../../Assets/nokaoi-imges/diamond-shape-img/black/Round.svg';
import PrincessBlack from '../../../../../Assets/nokaoi-imges/diamond-shape-img/black/Princess.svg';
import CushionBlack from '../../../../../Assets/nokaoi-imges/diamond-shape-img/black/Cushion.svg';
import EmeraldBlack from '../../../../../Assets/nokaoi-imges/diamond-shape-img/black/Emerald.svg';
import OvalBlack from '../../../../../Assets/nokaoi-imges/diamond-shape-img/black/Oval.svg';
import MarquiseBlack from '../../../../../Assets/nokaoi-imges/diamond-shape-img/black/Marquise.svg';
import RadiantBlack from '../../../../../Assets/nokaoi-imges/diamond-shape-img/black/Radiant.svg';
import PearBlack from '../../../../../Assets/nokaoi-imges/diamond-shape-img/black/Pear.svg';
import AsscherBlack from '../../../../../Assets/nokaoi-imges/diamond-shape-img/black/Asscher.svg';
import HeartBlack from '../../../../../Assets/nokaoi-imges/diamond-shape-img/black/Heart.svg';
import leftArrow from '../../../../../Assets/nokaoi-imges/left-arrow.png'
import rightArrow from '../../../../../Assets/nokaoi-imges/right-arrow.png'

const data = [
  { name: "Round", para: "Cut with the optimum light refraction and sparkle.",  imageColored:Round , imageBlack: RoundBlack, url: "/diamonds/shape=Round" },
  { name: "Princess", para: "A contemporary cut, with optimal fire and brilliance.",  imageColored: Princess, imageBlack: PrincessBlack, url: "/diamonds/shape=Princess" },
  { name: "Cushion", para: "With soft corners, a beautiful alternative to a round or princess cut.",  imageColored: Cushion, imageBlack: CushionBlack , url: "/diamonds/shape=Cushion" },
  { name: "Emerald", para: "This stylish cut creates rectangular facets with great stone clarity.",  imageColored: Emerald, imageBlack: EmeraldBlack, url: "/diamonds/shape=Emerald" },
  { name: "Oval", para: "Optimizes carat, giving the illusion of a larger stone.",  imageColored:Oval , imageBlack:OvalBlack , url: "/diamonds/shape=Oval" },
  { name: "Radiant", para: "The most brilliant of the rectangular cut diamonds.",  imageColored:Radiant , imageBlack:RadiantBlack , url: "/diamonds/shape=Radiant" },
  { name: "Asscher", para: "This unique shape is a square emerald, with linear facets.",  imageColored:Asscher , imageBlack:AsscherBlack , url: "/diamonds/shape=Asscher" },
  { name: "Marquise", para: "Elongates the finger of the wearer with a look of great grandeur.",  imageColored:Marquise , imageBlack:MarquiseBlack , url: "/diamonds/shape=Marquise" },
  { name: "Heart", para: "A rare cut that is a true testament of your relationship.",  imageColored: Heart, imageBlack:HeartBlack , url: "/diamonds/shape=Heart" },
  { name: "Pear", para: "Combining the brilliance and design of the Round and Marquise cuts.",  imageColored: Pear, imageBlack:PearBlack , url: "/diamonds/shape=Pear" },
];

const sliderSettings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 10, 
  slidesToScroll: 1,
   prevArrow: <Image src={leftArrow} alt="arrow"  className="img-fluid"/>,
    nextArrow: <Image src={rightArrow} alt="arrow"  className="img-fluid" />,
  responsive: [
    { breakpoint: 1024, settings: { slidesToShow: 8, slidesToScroll: 1, dots: false, arrows:false, autoplay:true, } },
    { breakpoint: 600, settings: { slidesToShow: 5, slidesToScroll: 2, dots: false, arrows:false, autoplay:true, } },
    { breakpoint: 480, settings: { slidesToShow: 3, slidesToScroll: 1, dots: false, arrows:false, autoplay:true, } },
  ],
  beforeChange: (current, next) => {
    document
      .querySelectorAll('.slick-slide[aria-hidden="true"] a, .slick-slide[aria-hidden="true"] button, .slick-slide[aria-hidden="true"] input')
      .forEach(el => el.setAttribute('tabindex', '-1'));
  },
  afterChange: () => {
    document
      .querySelectorAll('.slick-slide:not([aria-hidden="true"]) a, .slick-slide:not([aria-hidden="true"]) button, .slick-slide:not([aria-hidden="true"]) input')
      .forEach(el => el.removeAttribute('tabindex'));
  }
};

const ShopByDiamondShape = () => {

  const history = useHistory();
  const [diamondItem, setDiamondItem] = useState(data[0]);
  const [hoveredItem, setHoveredItem] = useState(null);

  // Optimize re-renders using useCallback
  const handleClick = useCallback((item) => {
    setDiamondItem(item);
  }, []);

  return (
    <section className="shop-diamond-by-shape">
      <Container fluid className="showcase-container">
        <Heading>
          <h2>Shop Diamonds By Shape</h2>
        </Heading>

        <div className="inner-shop-diamond-shape">
         
            <div className="diamonds-collection">
              <Slider {...sliderSettings}>
                {data.map((item) => (
                  <div
                    className="diamond-item cursor-pointer"
                    key={item.name}
                   onMouseEnter={() => setHoveredItem(item.name)}
          onMouseLeave={() => setHoveredItem(null)}
          // onClick={() => handleClick(item)}
          onClick={() => history.push(item.url)}
      style={{ cursor: "pointer" }}
                  >
                    {hoveredItem === item.name ? (
            <Image
              src={item.imageColored}
              alt={item.name}
              loading="lazy"
              className="shop_by_shape_hover_img"
            />
          ) : (
            <Image
              src={item.imageBlack}
              alt={item.name}
              loading="lazy"
              className="shop_by_shape_hover_img_black"
            />
          )}
                    <p className={diamondItem.name === item.name ? "name" : ""}>{item.name}</p>
                  </div>
                ))}
              </Slider>
            </div>
         
        </div>
      </Container>
    </section>
  );
};

export default ShopByDiamondShape;
